module.exports = __webpack_public_path__ + "img/machine-vision.46b2b38e.jpg";